var exports = {
  "j": "x4ddf2309--802b25--breadcrumbs",
  "n": "x4ddf2309--802b25--link",
};

module.exports = exports;
